<template>
	<div class="main-content" :style='{"color":"#666","padding":"20px 30px 30px","fontSize":"16px"}'>
		<!-- 列表页 -->
		<template v-if="showFlag">
			<el-form class="center-form-pv" :style='{"margin":"0 0 20px","fontSize":"inherit"}' :inline="true" :model="searchForm">
				<el-row :style='{"fontSize":"inherit","display":"block"}' >
					<div :style='{"margin":"0 10px 0 0","fontSize":"inherit","display":"inline-block"}'>
						<label :style='{"margin":"0 10px 0 0","color":"inherit","display":"inline-block","lineHeight":"40px","fontSize":"inherit","fontWeight":"500","height":"40px"}' class="item-label">工号</label>
						<el-input v-model="searchForm.gonghao" placeholder="工号" @keydown.enter.native="search()" clearable></el-input>
					</div>
					<div :style='{"margin":"0 10px 0 0","fontSize":"inherit","display":"inline-block"}'>
						<label :style='{"margin":"0 10px 0 0","color":"inherit","display":"inline-block","lineHeight":"40px","fontSize":"inherit","fontWeight":"500","height":"40px"}' class="item-label">姓名</label>
						<el-input v-model="searchForm.xingming" placeholder="姓名" @keydown.enter.native="search()" clearable></el-input>
					</div>
					<el-button class="search" type="success" @click="search()">
						<span class="icon iconfont icon-yanziwancheng" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff","height":"40px"}'></span>
						搜索
					</el-button>
				</el-row>

				<el-row class="actions" :style='{"flexWrap":"wrap","margin":"20px 0","display":"flex"}'>
					<el-button class="del" v-if="isAuth('hetong','删除')" :disabled="dataListSelections.length?false:true" type="danger" @click="deleteHandler()">
						<span class="icon iconfont icon-guanbi1" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff","height":"40px"}'></span>
						删除
					</el-button>
				</el-row>
			</el-form>
			<div :style='{"width":"100%","padding":"0","background":"none"}'>
				<el-table class="tables"
					:stripe='false'
					:style='{"padding":"0","borderColor":"#eee","color":"inherit","borderWidth":"1px 0 0 1px","background":"#fff","width":"100%","fontSize":"inherit","borderStyle":"solid"}' 
					:border='true'
					v-if="isAuth('hetong','查看')"
					:data="dataList"
					v-loading="dataListLoading"
				@selection-change="selectionChangeHandler">
					<el-table-column :resizable='true' type="selection" align="center" width="50"></el-table-column>
					<el-table-column :resizable='true' :sortable='true' label="序号" type="index" width="60" />
					<el-table-column :resizable='true' :sortable='true'  
						prop="gonghao"
						label="工号"
						width="120">
						<template slot-scope="scope">
							{{scope.row.gonghao}}
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="xingming"
						label="姓名"
						width="100">
						<template slot-scope="scope">
							{{scope.row.xingming}}
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="imageCount"
						label="图片数量"
						width="100"
						align="center">
						<template slot-scope="scope">
							<el-tag type="success">{{scope.row.imageCount || 0}}张</el-tag>
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true' prop="images" label="合同图片" min-width="300">
						<template slot-scope="scope">
							<div v-if="scope.row.images" style="display: flex; gap: 10px; flex-wrap: wrap;">
								<div v-for="(img, index) in scope.row.images.split(',')" :key="index" style="position: relative;">
									<img 
										v-if="img.substring(0,4)=='http'" 
										:src="img" 
										width="80" 
										height="80" 
										style="cursor: pointer; border-radius: 4px; object-fit: cover;"
										@click="previewImage(scope.row.images.split(','), index)">
									<img 
										v-else 
										:src="$base.url + img" 
										width="80" 
										height="80" 
										style="cursor: pointer; border-radius: 4px; object-fit: cover;"
										@click="previewImage(scope.row.images.split(',').map(i => $base.url + i), index)">
									<span style="position: absolute; top: 2px; left: 2px; background: rgba(0,0,0,0.6); color: white; padding: 2px 6px; border-radius: 3px; font-size: 12px;">{{index + 1}}</span>
								</div>
							</div>
							<div v-else style="color: #999;">暂无图片</div>
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="uploadTime"
						label="上传时间"
						width="180">
						<template slot-scope="scope">
							{{scope.row.uploadTime}}
						</template>
					</el-table-column>
					<el-table-column width="260" label="操作" fixed="right">
						<template slot-scope="scope">
							<el-button class="view" v-if="isAuth('hetong','查看')" type="success" size="small" @click="addOrUpdateHandler(scope.row.id,'info')">
								<span class="icon iconfont icon-dagou" :style='{"margin":"0 2px","fontSize":"inherit","color":"inherit","height":"40px"}'></span>
								查看
							</el-button>
							<el-button class="edit" v-if="isAuth('hetong','修改')" type="primary" size="small" @click="addOrUpdateHandler(scope.row.id)">
								<span class="icon iconfont icon-bianji" :style='{"margin":"0 2px","fontSize":"inherit","color":"inherit","height":"40px"}'></span>
								编辑
							</el-button>
							<el-button class="del" v-if="isAuth('hetong','删除')" type="danger" size="small" @click="deleteHandler(scope.row.id)">
								<span class="icon iconfont icon-guanbi1" :style='{"margin":"0 2px","fontSize":"inherit","color":"inherit","height":"40px"}'></span>
								删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-pagination
				@size-change="sizeChangeHandle"
				@current-change="currentChangeHandle"
				:current-page="pageIndex"
				background
				:page-sizes="[10, 20, 30, 50]"
				:page-size="pageSize"
				:layout="layouts.join()"
				:total="totalPage"
				prev-text="上一页 "
				next-text="下一页 "
				:hide-on-single-page="false"
				:style='{"padding":"0","margin":"20px 0 0","whiteSpace":"nowrap","color":"inherit","width":"100%","fontSize":"inherit","fontWeight":"500"}'
			></el-pagination>
		</template>
		
		<!-- 添加/修改页面 -->
		<add-or-update v-if="addOrUpdateFlag" :parent="this" ref="addOrUpdate"></add-or-update>
		
		<!-- 图片预览对话框 -->
		<el-dialog title="图片预览" :visible.sync="imagePreviewVisible" width="60%">
			<div style="text-align: center;">
				<img :src="previewImageUrl" style="max-width: 100%; max-height: 600px;" />
			</div>
			<div style="text-align: center; margin-top: 20px;">
				<el-button @click="prevImage" :disabled="previewIndex === 0">上一张</el-button>
				<span style="margin: 0 20px;">{{ previewIndex + 1 }} / {{ previewImageList.length }}</span>
				<el-button @click="nextImage" :disabled="previewIndex === previewImageList.length - 1">下一张</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import AddOrUpdate from "./add-or-update";
export default {
	data() {
		return {
			searchForm: {
				gonghao: "",
				xingming: ""
			},
			dataList: [],
			pageIndex: 1,
			pageSize: 10,
			totalPage: 0,
			dataListLoading: false,
			dataListSelections: [],
			showFlag: true,
			addOrUpdateFlag: false,
			layouts: ["total", "prev", "pager", "next", "sizes", "jumper"],
			// 图片预览
			imagePreviewVisible: false,
			previewImageUrl: '',
			previewImageList: [],
			previewIndex: 0
		};
	},
	components: {
		AddOrUpdate
	},
	activated() {
		this.getDataList();
	},
	methods: {
		// 获取数据列表
		getDataList() {
			this.dataListLoading = true;
			let params = {
				page: this.pageIndex,
				limit: this.pageSize,
				sort: 'id',
				order: 'desc'
			};
			
			if (this.searchForm.gonghao) {
				params.gonghao = this.searchForm.gonghao;
			}
			if (this.searchForm.xingming) {
				params.xingming = this.searchForm.xingming;
			}
			
			this.$http({
				url: "hetong/page",
				method: "get",
				params: params
			}).then(({ data }) => {
				if (data && data.code === 0) {
					this.dataList = data.data.list;
					this.totalPage = data.data.total;
				} else {
					this.dataList = [];
					this.totalPage = 0;
				}
				this.dataListLoading = false;
			});
		},
		
		// 每页数
		sizeChangeHandle(val) {
			this.pageSize = val;
			this.pageIndex = 1;
			this.getDataList();
		},
		
		// 当前页
		currentChangeHandle(val) {
			this.pageIndex = val;
			this.getDataList();
		},
		
		// 多选
		selectionChangeHandler(val) {
			this.dataListSelections = val;
		},
		
		// 搜索
		search() {
			this.pageIndex = 1;
			this.getDataList();
		},
		
		// 新增/修改
		addOrUpdateHandler(id, type) {
			this.showFlag = false;
			this.addOrUpdateFlag = true;
			if (id) {
				this.$nextTick(() => {
					this.$refs.addOrUpdate.init(id, type);
				});
			}
		},
		
		// 删除
		deleteHandler(id) {
			var ids = id
				? [Number(id)]
				: this.dataListSelections.map(item => {
						return Number(item.id);
				  });
			this.$confirm(`确定要删除选中的${ids.length}条记录吗?`, "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				this.$http({
					url: "hetong/delete",
					method: "post",
					data: ids
				}).then(({ data }) => {
					if (data && data.code === 0) {
						this.$message({
							message: "操作成功",
							type: "success",
							duration: 1500
						});
						this.search();
					} else {
						this.$message.error(data.msg);
					}
				});
			});
		},
		
		// 图片预览
		previewImage(imageList, index) {
			this.previewImageList = imageList;
			this.previewIndex = index;
			this.previewImageUrl = imageList[index];
			this.imagePreviewVisible = true;
		},
		
		// 上一张
		prevImage() {
			if (this.previewIndex > 0) {
				this.previewIndex--;
				this.previewImageUrl = this.previewImageList[this.previewIndex];
			}
		},
		
		// 下一张
		nextImage() {
			if (this.previewIndex < this.previewImageList.length - 1) {
				this.previewIndex++;
				this.previewImageUrl = this.previewImageList[this.previewIndex];
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.icon {
	cursor: pointer;
}
</style>




